import { reactive, computed } from 'vue'

import { useDialog } from '@/services/useDialog'
import { usePoliticalActions } from './usePoliticalActions'

const activityDialog = reactive({
  currentDocumentType: 'request',
  tabIndex: 0,
  isPreview: false,
  isPreviewEnabled: false,
  isPreviewResult: false,
  isPreviewResultEnabled: false,
  isPreviewMemory: false,
  // isPreviewMemoryEnabled: false,
  isPreviewMemoryEnabled: true,
  isPreviewImg: false,
  isOffice: false,
  isOfficeResult: false,
  isOfficeMemory: false,
})

const tabIndex = reactive(0)

const { openDialog } = useDialog()

export const usePoliticalActionDialog = () => {
  const { setCurrentPoliticalAction } = usePoliticalActions()

  const changeDocument = async (docType, docId) => {
    let type = ''
    if (docType == 3) {
      type = 'request'
    } else if (docType == 4) {
      type = 'result'
    } else if (docType == 5) {
      type = 'memory'
    } else {
      type = docType
    }
    changeDocumentTitle(type)
    const res = await setCurrentPoliticalAction(docId)
    if (res) openDialog('politicalAction')
  }

  // 政務活動ページのダイアログを開く際に使用
  const changeDocumentActivities = async (docType, docId, status) => {
    const { canOpenActivitiesDialog } = usePoliticalActions()
    if (!canOpenActivitiesDialog(status)) return

    let type = ''
    if (docType == 3) {
      type = 'request'
    } else if (docType == 4) {
      type = 'result'
    } else if (docType == 5) {
      type = 'memory'
    } else {
      type = docType
    }
    changeDocumentTitle(type, canOpenActivitiesDialog(status))
    const res = await setCurrentPoliticalAction(docId)
    if (res) openDialog('politicalAction')
  }

  const changeDocumentTitle = (docType, canChange = true) => {
    if (!canChange) return
    activityDialog.currentDocumentType = docType
    activityDialog.isPreview = false
    activityDialog.isOffice = false
    activityDialog.isPreviewResult = false
    activityDialog.isOfficeResult = false
    activityDialog.isPreviewMemory = false
    activityDialog.isOfficeMemory = false
  }

  const dialogTitle = computed(() => {
    let title = ''

    switch (activityDialog.currentDocumentType) {
      case 'request':
        activityDialog.tabIndex = 0
        title = '①申請書'
        break
      case 'result':
        activityDialog.tabIndex = 1
        title = '②報告書'
        break
      case 'memory':
        activityDialog.tabIndex = 2
        title = '③記録簿'
        break
    }
    return title
  })

  const showPreview = isShown => {
    activityDialog.isPreview = isShown
    activityDialog.isOffice = isShown
  }

  const showPreviewResult = isShown => {
    activityDialog.isPreviewResult = isShown
    activityDialog.isOfficeResult = isShown
  }

  const showPreviewMemory = isShown => {
    activityDialog.isPreviewMemory = isShown
    activityDialog.isOfficeMemory = isShown
  }

  const showPreviewImg = isShown => {
    activityDialog.isPreviewImg = isShown
  }

  return {
    activityDialog,
    dialogTitle,
    tabIndex,
    changeDocument,
    changeDocumentActivities,
    changeDocumentTitle,
    showPreview,
    showPreviewResult,
    showPreviewMemory,
    showPreviewImg,
  }
}
